// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2HrO7","disabled":"FileBtn_disabled__1CGSK","warn":"FileBtn_warn__3GfKu","fade":"FileBtn_fade__n9kkI"};